<header class="page-header">
    <div class="top-bar-container">
        <img src="../../assets/images/pokemon" alt="Pokemon">
    </div>
</header>

<router-outlet></router-outlet>